<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.administrative.hours_recording.title')" header-tag="h3" class="bg-default-card">
                    <div class="row" v-if="this.$store.getters.hasPermission(['project_hours_recording'], ['read']) && tableLoaded">
                        <div class="mt-2 ml-3">
                            <select class="form-control" v-model="month">
                                <option v-for="month in months" :value="month.code" :key="month.code">{{month.name}}</option>
                            </select>
                        </div>

                        <div style="width: 100px; margin: 7px 10px 0px 10px">
                            <input type="number" onKeyPress="if(this.value.length==4) return false;" class="form-control" v-model="year">
                        </div>

                        <button @click="filterBy" class="btn btn-primary mt-2" style="height: 33.5px;" :disabled="$store.state.ajax_in_progress">
                            <i class="fa fa-filter mr-1 p-0"></i>{{$t('table.filter')}}
                        </button>
                    </div>

                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_hours_recording'], ['read'])" title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowCalendarO="onCalendarORow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                    >
                    </data-table>

                    <b-btn class="btn btn-default mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_hours_recording'], ['create'])"><i class="fa fa-plus-circle mr-1"></i> {{$t('general.administrative.hours_recording.add_record')}}</b-btn>
                </b-card>

                <div class="row">
                    <div class="col-sm-12">
                        <span v-if="this.$store.getters.hasPermission(['project_hours_recording'], ['read']) && getData.rowData.length > 0" class="mr-2">
                            <i class="fa fa-2x fa-calendar-o text-success"></i> - {{$t('general.buttons.hour_recording')}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="chooseDate" ref="chooseDate" :title="actionTitle" size="md" @ok="onChooseDate" @hidden="hideChooseDateModal">
            <div class="row">
                <div class="col-sm-12">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.choose_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.copy_date"></flat-pickr>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <hours-recording-per-day-table
            ref="hoursRecordingPerDayTable"
            :tableName="tableName"
            :copyDate="model.copy_date"
            :userID="model.user_id"
            :userFullName="model.fullname"
            @onLoadTable="onLoadTable"
            @goBack="openCopyDateModal"
        >
        </hours-recording-per-day-table>

        <hours-recording-modal
            ref="hoursRecordingModal"
            :modalTitle="actionTitle"
            :tableName="tableName"
            :tableNameTranslated="tableNameTranslated"
            :isEdit="false"
            :isAdd="true"
            @onLoadTable="onLoadTable"
        >
        </hours-recording-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import HoursRecordingPerDayTable from '@/components/pages/project/administrative/hours_recording/hours_recording_per_day_table.vue';
import HoursRecordingModal from '@/components/global/modals/HoursRecordingModal.vue';

export default {
    name: 'hours_recording',
    components: {
        DataTable,
        flatPickr,
        notificationIcons,
        HoursRecordingPerDayTable,
        HoursRecordingModal,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.administrative.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.administrative.hours_recording.title'),
                    active: true
                }
            ],
            month: '',
            year: '',
            tableNameTranslated: Vue.i18n.translate('general.administrative.hours_recording.title_modal'),
            tableName: 'hoursrecording',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            pageCount: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            filterByDate: '',
            actionTitle: '',

            getData: {
                rowData: []
            },
            model: {
                copy_date: null,
                user_id: null,
                fullname: null,
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    field: '',
                    showCalendarOButton: true,
                },
                {
                    label: Vue.i18n.translate('table.user'),
                    field: 'user.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('1'),
                    field: 'a1',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('2'),
                    field: 'a2',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('3'),
                    field: 'a3',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('4'),
                    field: 'a4',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('5'),
                    field: 'a5',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('6'),
                    field: 'a6',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('7'),
                    field: 'a7',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('8'),
                    field: 'a8',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('9'),
                    field: 'a9',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('10'),
                    field: 'a10',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('11'),
                    field: 'a11',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('12'),
                    field: 'a12',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('13'),
                    field: 'a13',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('14'),
                    field: 'a14',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('15'),
                    field: 'a15',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('16'),
                    field: 'a16',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('17'),
                    field: 'a17',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('18'),
                    field: 'a18',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('19'),
                    field: 'a19',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('20'),
                    field: 'a20',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('21'),
                    field: 'a21',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('22'),
                    field: 'a22',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('23'),
                    field: 'a23',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('24'),
                    field: 'a24',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('25'),
                    field: 'a25',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('26'),
                    field: 'a26',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('27'),
                    field: 'a27',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('28'),
                    field: 'a28',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('29'),
                    field: 'a29',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('30'),
                    field: 'a30',
                    numeric: false,
                    html: false,
                },
                {
                    label: ('31'),
                    field: 'a31',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.total_hours'),
                    field: 'hourstotal',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted () {
        this.month = new Date().getMonth() + 1;
        this.year  = new Date().getFullYear();

        this.onLoadTable();
    },
    computed: {
        months: {
            get: function () {
                let months = this.$store.getters.getMonths;
                return months;
            }
        }
    },
    watch: {
        months: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 4000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        filterBy () {
            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        onLoadTable () {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&month=' + this.month + '&year=' + this.year).get().then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    this.getData.rowData = response.data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$refs.hoursRecordingModal.show();
        },
        openCopyDateModal () {
            this.actionTitle = Vue.i18n.translate('modal.general.choose_records_per_day');
            this.$refs.chooseDate.show();
        },
        onCalendarORow (row) {
            this.model.user_id  = row.user_id;
            this.model.fullname = row.user.fullname;
            this.openCopyDateModal();
        },
        onChooseDate (e) {
            if (this.model.copy_date == 'undefined' || this.model.copy_date == null || this.model.copy_date == '') {
                e.preventDefault();
                this.errorMsg(Vue.i18n.translate('errors.choose_a_date'));
                return false;
            } else {
                this.$refs.chooseDate.hide();
                this.$refs.hoursRecordingPerDayTable.showModal();
            }
        },
        hideChooseDateModal () {
            // this.model.copy_date = null;
            // this.model.user_id   = null;
            // this.model.fullname  = null;
        },
        onExportButton() {
            http.route('hoursrecording?project_id=' + this.$route.params.id).exportExcel({
                export:1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'hours_recording.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/project/administrative/hours_recording/hours_recording.vue